// import instance from your axios setup
import instance from "../api/axios";

// Function to fetch districts
export const getDistricts = async () => {
  try {
    const response = await instance.get("/districts");
    return response.data.districts;
  } catch (error) {
    console.error("Error fetching districts:", error);
    return [];
  }
};